module.exports = __webpack_public_path__ + "04_medium_gray.f066ca26.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_medium_gray.png
// module id = XyBW
// module chunks = 0